export default "__VITE_ASSET__DSOR9ahH__"